import React, { ReactNode, useEffect } from "react";
import { Provider } from "react-redux";
import { useMount } from "react-use";
import "./msgs/ClientMsgReceiver";
import {
    requestListEvens,
    requestListPassiveMappers,
    requestListSchedules,
    requestQuerySchedulables,
} from "./msgs/MsgSender";
import scheduleStore, { ScheduleContext } from "./scheduleStore";

interface IProps {
    appID?: string;
    children: ReactNode;
}

function ScheduleProvider(props: IProps) {
    useMount(() => {
        requestListSchedules();
        requestListEvens();
        requestListPassiveMappers();
        requestQuerySchedulables();
    });

    return (
        <Provider store={scheduleStore} context={ScheduleContext}>
            {props.children}
        </Provider>
    );
}

export default ScheduleProvider;
